module.exports = __webpack_public_path__ + "img/new-tag.7279d0e8.png";